// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"3":"d097415d","15":"dd205a5a","139":"4de80a5e","332":"180c5852","620":"f3516b37","670":"4471d963"}[chunkId] + ".css";
};